var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"enter-active-class":"animated faster zoomIn"}},[_c('div',{staticClass:"comment_wrap"},[_c('comment-item',{attrs:{"image":_vm.image,"comments":_vm.comments},on:{"create":_vm.createComment,"change":_vm.changeComment,"reset":_vm.resetCommentsData}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }